import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import moment from 'moment';
import "moment-timezone";

class Ora extends React.Component {

    constructor() {
        super();
        this.state = {
            ora: '',
        };
    }

    componentDidMount() {
        this.intervalId = setInterval(this.timer.bind(this), 1000);

        // Add/Subtract GMT
        // var current_hour
        // var gmt = moment().format('ZZ')
        // var server_time = this.props.serverTime.date_server_time
        // var hours = parseInt(gmt.slice(1, 3))

        // if (gmt.slice(0, 1) === '+') {
        //     current_hour = moment(server_time).add(hours, 'hours')
        // } else if (gmt.slice(0, 1) === '-') {
        //     current_hour = moment(server_time).subtract(hours, 'hours')
        // }

        if (this.state.ora === '') {
            this.setState({
                ora: this.props.serverTime.date_server_time
            });
        }
    }
    componentWillUnmount() {
        clearInterval(this.intervalId);
    }
    timer() {
        if (this.props.serverTime) {
            this.setState({
                ora: moment(this.state.ora).add(1, 'seconds'),
            })
        }
    }
    render() {

        if (this.props.serverTime) {
            return (
                <div className="module-header currentTime">
                    {moment(this.state.ora).format('HH:mm:ss') + ' (GMT' + moment(this.state.ora).format('ZZ') + ')'}
                </div>
            )
        } else {
            return <div></div>
        }
    }
}
function mapStateToProps(state) {
    return {
        serverTime: state.serverTime
    }
}
function matchDispatchToProps(dispatch) {
    return bindActionCreators({

    }, dispatch)
}
export default connect(mapStateToProps, matchDispatchToProps)(Ora);